type PlannerPlansListColumnsButtonProps = {
  id?: string;
  disabled?: boolean;
};

export const PlannerPlansListColumnsButton = ({ id, disabled }: PlannerPlansListColumnsButtonProps) => {
  // const { run: setTableColumns, tableColumns } = useSetProjectPlansColumns();
  // return (
  //   <TableColumnsButton
  //     id={id}
  //     intlIdPrefix="planner.plans.table"
  //     disabled={disabled}
  //     tableColumns={tableColumns}
  //     setTableColumns={setTableColumns}
  //     defaultTableColumns={PROJECT_PLANS_DEFAULT_TABLE_COLUMNS}
  //   />
  // );
  return null;
};
